import { render, staticRenderFns } from "./RelatorioQuantidadeVisualizacaoProduto.vue?vue&type=template&id=05a91df2"
import script from "./RelatorioQuantidadeVisualizacaoProduto.vue?vue&type=script&lang=js"
export * from "./RelatorioQuantidadeVisualizacaoProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports